import component from "./FullWithLayout";
export default component;
